import { render, staticRenderFns } from "./decoration-reply-refer-form.vue?vue&type=template&id=ddae389c&scoped=true&"
import script from "./decoration-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./decoration-reply-refer-form.vue?vue&type=script&lang=js&"
import style0 from "./decoration-reply-refer-form.vue?vue&type=style&index=0&id=ddae389c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddae389c",
  null
  
)

export default component.exports